/*
  nb-drawer-autoopen.js
  Åbner kurv-draweren efter ENHVER vellykket tilføjelse til kurven,
  uanset hvilken sektion der udløste den. Additiv: rører ingen eksisterende
  handlere og ændrer ingen markup. Idempotent — kører kun én gang.

  Baggrund: cart-drawer.liquid lover at draweren åbner automatisk, men på
  produktsider udenfor plakat-templaten blev varen lagt i kurven uden nogen
  visuel bekræftelse. Denne fil lukker det hul globalt.
*/
(function () {
  if (window.__nbDrawerAutoOpen) return;
  window.__nbDrawerAutoOpen = true;

  var sidst = 0;

  function erAdd(url, method) {
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  function aabn() {
    var nu = Date.now();
    if (nu - sidst < 400) return; /* undgå dobbeltåbning ved flere kald */
    sidst = nu;

    if (!window.NBCart) return;
    try {
      var r = (typeof NBCart.refresh === 'function') ? NBCart.refresh() : null;
      Promise.resolve(r)
        .then(function () { if (typeof NBCart.open === 'function') NBCart.open(); })
        .catch(function () { if (typeof NBCart.open === 'function') NBCart.open(); });
    } catch (e) {
      try { if (NBCart.open) NBCart.open(); } catch (e2) {}
    }
  }

  /* fetch */
  if (typeof window.fetch === 'function') {
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var traef = erAdd(url, method);
      return orig.apply(this, arguments).then(function (res) {
        if (traef && res && res.ok) setTimeout(aabn, 80);
        return res;
      });
    };
  }

  /* XMLHttpRequest */
  var xOpen = XMLHttpRequest.prototype.open;
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__nbAdd = erAdd(u, m);
    return xOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (x.__nbAdd) {
      x.addEventListener('load', function () {
        if (x.status >= 200 && x.status < 300) setTimeout(aabn, 80);
      });
    }
    return xSend.apply(this, arguments);
  };
})();
